<template>
    <div>
        <vue-progress-bar />
        <router-view v-show="!$store.state.app.globalSearch" />
        <flash-message />
        <global-search :show="$store.state.app.globalSearch" />
        <new-version-modal :show="$store.state.app.newVersionAvailable" />
    </div>
</template>

<script>
import FlashMessage from '@/components/notifications/FlashMessage.vue';
import GlobalSearch from '@/components/modals/GlobalSearchModal.vue';
import NewVersionModal from '@/components/modals/NewVersionModal.vue';

export default {
    components: {
        FlashMessage,
        GlobalSearch,
        NewVersionModal,
    },

    data() {
        return {
            direction: 'ltr',
            showNavigationConfirmation: false,
            versionReleaseDate: '2021-02-05T08:15:30-05:00', //date should be UTC
        };
    },

    mounted() {
        this.$Progress.finish();
        //TODO remove user should auto init
        this.$user.initialize();
    },

    created() {
        //  [App.vue specific] When App.vue is first loaded start the progress bar
        // this.$Progress.start()

        //  hook the progress bar to start before we move router-view
        this.$router.beforeEach((to, from, next) => {
            //  start the progress bar
            this.$Progress.start();
            next();
        });

        //  hook the progress bar to finish after we've finished moving router-view
        this.$router.afterEach((to, from) => {
            this.$Progress.finish();
        });
    },

    methods: {
        confirmNavigation() {
            this.$root.showNavigationConfirmation = true;
        },
    },
};
</script>
